/** @format */

import React, { useState } from 'react';
import { Grid, Button } from '@mui/material';
import { InputV2, PickList, Icons } from 'components';
import { makeStyles } from '@mui/styles';
import validator from 'validator';
import createToast from 'components/Toast/Toast';

export default function IPs({ items = [], setItems, ...props }) {
  // --STATES--//
  const [IP, setIP] = useState('');
  const [counter, setCounter] = useState(1);
  // --HOOKS--//
  const classes = useStyles();

  // --API--//

  // -- OTHER FUNCTIONS --//
  const removeItem = (item) => {
    const tempItems = [...items];
    const index = tempItems.findIndex((v) => v == item);
    tempItems.splice(index, 1);
    setItems([...tempItems]);
  };

  const addItem = (item) => {
    if (!item || item?.length == 0) {
      createToast('خطا', 'ابتدا IP را وارد نمایید', 'danger');

      return;
    }
    let errMsg = '';

    const tempItems = [...items];
    if (item.includes(',')) {
      const trimed = item.trim().replace(' ', '');
      const incomming = trimed.split(',');
      incomming.map((v) => {
        if (!tempItems.includes(v)) {
          if (validator.isIP(v) || v == '*') {
            tempItems.push(v);
          } else {
            errMsg += `${'فرمت IP وارد شده ' + '('}${v}) ` + `صحیح نیست,`;
          }
        }
      });
      setIP('');
    } else {
      const trimed = item.trim().replace(' ', '');
      if (!tempItems.includes(trimed)) {
        if (validator.isIP(trimed) || trimed == '*') {
          tempItems.push(trimed);
          setIP('');
        } else {
          errMsg = 'فرمت IP وارد شده صحیح نیست';
        }
      } else {
        createToast('خطا', 'مقدار وارد شده تکراری است', 'danger');

        return;
      }
    }

    if (errMsg != '') {
      createToast('خطا', errMsg, 'danger');
    }
    setItems([...tempItems]);
  };

  const onSelectFile = (e) => {
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      const file = e.target.files[0];
      if (!file) {
        createToast('خطا', 'ابتدا یک فایل .txt انتخاب کنید', 'danger');
      }
      setCounter(counter + 1);
      const reader = new FileReader();
      const textFile = /text.*/;

      if (file?.type?.match(textFile)) {
        reader.onload = function (event) {
          try {
            const lines = event.target.result.split('\n');

            let oneLineList = '';

            lines.forEach((item, k) => {
              const trimed = item.trim().replace(' ', ''); // remove persian space
              oneLineList += trimed;
              if (k != lines.length - 1) {
                oneLineList += ',';
              }
            });

            addItem(oneLineList);
          } catch (error) {

            createToast('خطا', 'خطایی در پردازش فایل رخ داده', 'danger');
          }
        };
      } else {
        createToast('خطا', 'فایل انتخاب شده معتبر نمی‌باشد', 'danger');
      }
      reader.readAsText(file);
    } else {
      createToast('خطا', 'مرورگر شما از این ویژگی پشتیبانی نمی‌کند', 'danger');
    }
  };
  // -- LOCAL VARIABLES --//

  return (
    <Grid container direction="column" xs={12}>
      <Grid item container xs={12} alignItems="flex-end" style={{ marginBottom: 20 }}>
        <Grid item xs={12} md={6} lg={4}>
          <InputV2
            errors={{}}
            name="ip"
            label="آدرس IP را وارد کنید:"
            placeholder="می‌توانید چند IP را با کاراکتر ',' از هم جدا کنید"
            register={{}}
            // rules={['required']}
            dir="ltr"
            forceValue={IP}
            englishNumber
            fullWidth
            onChangeValue={(e) => setIP(e?.target?.value)}
            mainStyle={{ margin: 0, width: '100%' }}
            inputProps={{ style: { marginBottom: 0 } }}
            onKeyDown={(e) => {
              if (e?.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                addItem(IP);
                return false;
              }
            }}
          //   TODO: add validation rules
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4} className={classes.actions}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              addItem(IP);
            }}
            variant="contained"
            color="primary"
            typr="button"
            style={{ marginInlineStart: 10 }}
          >
            ثبت IP
          </Button>
          <input
            key={counter}
            hidden
            accept="text/plain"
            id="raised-button-file-ip"
            type="file"
            multiple={false}
            onChange={onSelectFile}
          />
          <Button
            startIcon={<Icons icon="Document" color="#2b3990" size="23" />}
            variant="contained"
            style={{ marginInlineStart: 10, padding: 15 }}
          >
            <label htmlFor="raised-button-file-ip" style={{ cursor: 'pointer' }}>
              بارگزاری فایل .txt
            </label>
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <PickList
          ltr
          items={items}
          onRemove={removeItem}
          title="IP"
          titleProps={{ style: { fontFamily: 'Vazir' } }}
        />
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    actions: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginInlineStart: theme.spacing(-1),
      },
    },
  };
});
